// extracted by mini-css-extract-plugin
export default {"destinationSelector":"DestinationSelector_destinationSelector__hhyt-"};